const Stat = ({ label, value, accent, big }) => (
  <div className="bg-[#141414] border border-white/10 p-4 rounded-sm flex flex-col">
    <span className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-1">{label}</span>
    <span
      className={`font-display font-black tabular ${big ? "text-6xl" : "text-4xl"} leading-none`}
      style={accent ? { color: accent } : {}}
    >
      {value}
    </span>
  </div>
);

export default function Scoreboard({ data, large = false }) {
  if (!data) return null;
  const t = data.by_type || {};
  return (
    <section className="space-y-3" data-testid="scoreboard">
      <div className="flex items-baseline justify-between border-b border-white/10 pb-2">
        <h2 className="font-display text-2xl font-black uppercase tracking-wider">Today</h2>
        <span className="text-[10px] uppercase tracking-[0.3em] text-white/40">Live</span>
      </div>
      <div className={`grid ${large ? "grid-cols-3 gap-4" : "grid-cols-2 md:grid-cols-3 gap-2"}`}>
        <Stat label="Opportunities" value={data.total_opportunities} accent="#34C759" big={large} />
        <Stat label="Available Now" value={data.available_now} big={large} />
        <Stat label="T.O. Rate" value={`${data.to_rate}%`} accent="#007AFF" big={large} />
        <Stat label="Walk-Ins" value={t.walk_in || 0} />
        <Stat label="Appointments" value={t.appointment || 0} />
        <Stat label="Phone Ups" value={t.phone_up || 0} />
        <Stat label="Be-Backs" value={t.be_back || 0} />
        <Stat label="Avg Time (min)" value={data.avg_time_minutes} />
        <Stat label="Close %" value={`${data.close_rate}%`} accent="#FFCC00" />
      </div>

      {data.per_salesperson?.length > 0 && (
        <div className="bg-[#141414] border border-white/10 p-4 rounded-sm">
          <div className="text-[10px] uppercase tracking-[0.3em] text-white/40 mb-3">Top Salespeople Today</div>
          <div className="space-y-2">
            {data.per_salesperson.slice(0, 6).map((sp, i) => (
              <div key={sp.name + i} className="flex items-center gap-3">
                <span className="font-display tabular font-black text-xl text-white/30 w-6 text-right">{i + 1}</span>
                <span className="font-display font-bold uppercase tracking-wide flex-1 truncate">{sp.name}</span>
                <span className="font-display tabular font-black text-2xl text-[#34C759]">{sp.count}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
